import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({color = '#B1BAC2', width = 'auto', height = 'auto', className = ''}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 32 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>paperticket-30px</title>

    <g>
      <g fill={color} fillRule="nonzero">
        <path
          d="M2.74954297,0.058500914 L2.74954297,8.01462523 L0,15.5027422 L27.4954297,25.5063985 L30.0694699,18.369287 L27.9634369,17.3162706 L26.0914077,22.5228519 L22.8153565,21.2943327 L24.6288848,16.3802559 L26.1499086,16.3802559 L30.8299818,16.3802559 L32,16.3802559 L32,0 L2.74954297,0 L2.74954297,0.058500914 Z M20.6508227,20.5338208 L10.7641682,16.9067642 L10.9396709,16.3802559 L22.1718464,16.3802559 L20.6508227,20.5338208 L20.6508227,20.5338208 Z M23.809872,14.0987203 L13.2797075,14.0987203 L13.2797075,12.928702 L7.42961609,12.928702 L7.42961609,14.0987203 L5.08957952,14.0987203 L5.08957952,2.39853747 L7.42961609,2.39853747 L7.42961609,3.56855575 L13.2797075,3.56855575 L13.2797075,2.39853747 L23.809872,2.39853747 L23.809872,14.0987203 L23.809872,14.0987203 Z M29.6599634,14.0987203 L26.1499086,14.0987203 L26.1499086,2.39853747 L29.6599634,2.39853747 L29.6599634,14.0987203 Z M7.42961609,4.73857404 L13.2797075,4.73857404 L13.2797075,5.90859232 L7.42961609,5.90859232 L7.42961609,4.73857404 Z M7.42961609,7.0786106 L13.2797075,7.0786106 L13.2797075,9.41864717 L7.42961609,9.41864717 L7.42961609,7.0786106 Z M7.42961609,10.5886655 L13.2797075,10.5886655 L13.2797075,11.7586837 L7.42961609,11.7586837 L7.42961609,10.5886655 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);

SVG.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,

  /**
   * Color hex code
   */
  color: PropTypes.string,

  /**
   * Icon width
   */
  width: PropTypes.string,

  /**
   * Icon height
   */
  height: PropTypes.string,
};
export default SVG;
